import React, { Fragment, useEffect, useReducer, useState } from "react";
import { Modal, Tab, Nav } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

import PageTitle from "../../layouts/PageTitle";
import { IMAGES } from "../../constant/theme";

const ProgressBar = [
  { title: "Photoshop", percent: "70%", color: "danger" },
  { title: "Code Editor", percent: "85%", color: "info", space: "mt-4" },
  { title: "Illustrator", percent: "65%", color: "success", space: "mt-4" },
];

const detailblog = [
  { title: "Gender", subtitle: "Male" },
  { title: "Education", subtitle: "PHD" },
  { title: "Designation", subtitle: "Sr. Professor" },
  { title: "Operation Done", subtitle: "120" },
];

const socialDetail = [
  {
    name: "Followers",
    number: "1204",
    title: "Projects",
    task: "150",
    border: "border-end",
  },
  {
    name: "Following",
    number: "2540",
    title: "Uploads",
    task: "140",
    border: "border-end",
  },
  { name: "Friends", number: "2540", title: "Tasks", task: "45" },
];

const initialState = false;
const reducer = (state, action) => {
  switch (action.type) {
    case "sendMessage":
      return { ...state, sendMessage: !state.sendMessage };
    case "postModal":
      return { ...state, post: !state.post };
    case "linkModal":
      return { ...state, link: !state.link };
    case "cameraModal":
      return { ...state, camera: !state.camera };
    case "replyModal":
      return { ...state, reply: !state.reply };
    default:
      return state;
  }
};

const personalDetail = [
  { title: "Name", subtitle: "Mitchell C.Shay" },
  { title: "Email", subtitle: "info@example.com" },
  { title: "Availability", subtitle: "Full Time (Free Lancer)" },
  { title: "Age", subtitle: "27" },
  { title: "Location", subtitle: "Rosemont Avenue Melbourne, Florida" },
  { title: "Year Experience", subtitle: "07 Year Experiences" },
];

function StaffProfile() {
  const [state, dispatch] = useReducer(reducer, initialState);

  const location = useLocation();
  const formData = location.state?.formData || {}; // Received data from navigation
  const [paymentStatus, setPaymentStatus] = useState("Unpaid");

  useEffect(() => {
    // Default payment status on load
    setPaymentStatus("Unpaid");
  }, []);

  const handlePaymentChange = (e) => {
    setPaymentStatus(e.target.value);
  };

  // Prepare personal detail items dynamically
  const personalDetail = [
    { title: "Student Name", subtitle: formData.studentName || "-" },
    { title: "Date of Birth", subtitle: formData.dob || "-" },
    { title: "Age", subtitle: formData.age || "-" },
    { title: "Gender", subtitle: formData.sex || "-" },
    { title: "Package", subtitle: formData.package || "-" },
    { title: "Address", subtitle: formData.address || "-" },
    { title: "Mobile Number", subtitle: formData.mobileNumber || "-" },
    { title: "School / College", subtitle: formData.schoolName || "-" },
    { title: "Batting", subtitle: formData.batting || "-" },
    { title: "Bowling", subtitle: formData.bowling || "-" },
    { title: "Wicket Keeping", subtitle: formData.wicketKeeping || "-" },
    { title: "Other Club Member", subtitle: formData.otherClub || "-" },
    { title: "Parent Name", subtitle: formData.parentName || "-" },
    { title: "Date of Joining", subtitle: formData.joiningDate || "-" },
    { title: "Amount Deposited", subtitle: formData.amountDeposited || "-" },
    { title: "Selected Package", subtitle: formData.selectedPackage || "-" },
    { title: "Receipt No", subtitle: formData.receiptNo || "-" },
  ];

  return (
    <>
      <div className="row">
        <div className="col-xl-9 col-xxl-8 col-lg-8">
          <div className="row">
            <div className="col-lg-12">
              <div className="card overflow-hidden">
                <div
                  className="text-center p-3 overlay-box"
                  style={{ backgroundImage: `url(${IMAGES.BigImg1})` }}
                >
                  <div className="profile-photo"></div>
                  <h3 className="mt-3 mb-1 text-white">Deangelo Sena</h3>
                  <p className="text-white mb-0">Player</p>
                </div>
                <div className=" row">
                  {personalDetail.map((data, index) => (
                    <div
                      key={index}
                      className="list-group-item d-flex justify-content-between col-md-6 col-6"
                    >
                      <span className="mb-0">{data.title}</span>{" "}
                      <strong className="text-muted">{data.subtitle}</strong>
                    </div>
                  ))}
                </div>
                {/* <div className="card-footer text-center border-0 mt-0">
                  <Link to={"#"} className="btn btn-primary  px-4 me-1">
                    Follow
                  </Link>
                  <Link to={"#"} className="btn btn-warning  px-4">
                    Message
                  </Link>
                </div> */}
              </div>
            </div>
            {/* <div className="col-lg-12">
              <div className="card overflow-hidden">
                <div className="card-header">
                  <h2 className="card-title">about me</h2>
                </div>
                <div className="card-body pb-0">
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry.
                  </p>
                  <ul className="list-group list-group-flush">
                    {detailblog.map((item, ind) => (
                      <li
                        className="list-group-item d-flex px-0 justify-content-between"
                        key={ind}
                      >
                        <strong>{item.title}</strong>
                        <span className="mb-0">{item.subtitle}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="card-footer pt-0 pb-0 text-center">
                  <div className="row">
                    {socialDetail.map((data, i) => (
                      <div className={`col-4 pt-3 pb-3 ${data.border}`} key={i}>
                        <h3 className="mb-1 text-primary">{data.task}</h3>
                        <span>{data.title}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div> */}
            {/* <div className="col-lg-12">
                            <div className="card">
                                <div className="card-header d-block">
                                    <h4 className="card-title">Address </h4>
                                </div>
                                <div className="card-body">
                                    <p className="mb-0">Demo Address #8901 Marmora Road Chi Minh City, Vietnam</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-header d-block">
                                    <h4 className="card-title">Work Expertise </h4>
                                </div>
                                <div className="card-body">
                                    {ProgressBar.map((item, ind)=>(
                                        <Fragment key={ind}>
                                            <h6 className={`${item.space}`}>{item.title}
                                                <span className="pull-right">{item.percent}</span>
                                            </h6>
                                            <div className="progress ">
                                                <div className={`progress-bar progress-animated bg-${item.color}`} style={{width: item.percent, height:"6px"}}>
                                                    <span className="sr-only">{item.percent} Complete</span>
                                                </div>
                                            </div>
                                        </Fragment>
                                    ))}
                                    
                                </div>
                            </div>
                        </div> */}
          </div>
        </div>
        <div className="col-xl-3 col-xxl-4 col-lg-4">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="profile-tab">
                    <div className="custom-tab-1">
                      <Tab.Container defaultActiveKey={"Posts"}>
                        <Nav as="ul" className="nav nav-tabs">
                          <Nav.Item as="li">
                            <Nav.Link eventKey="Posts">Fee Status</Nav.Link>
                          </Nav.Item>
                          {/* <Nav.Item as="li">
                            <Nav.Link eventKey="AboutMe">Fee Status</Nav.Link>
                          </Nav.Item> */}
                        </Nav>
                        <Tab.Content className="tab-content">
                          <Tab.Pane eventKey={"Posts"}>
                            <div className="profile-about-me">
                              <div className="pt-4 border-bottom-1 pb-4">
                                <h4 className="text-primary mb-4">
                                  Payment Information
                                </h4>
                                <div className="row mb-3">
                                  <div className="col-sm-6">
                                    <h6>Payment Status:</h6>
                                    <select
                                      className="form-select"
                                      value={paymentStatus}
                                      onChange={handlePaymentChange}
                                    >
                                      <option value="Unpaid">Unpaid</option>
                                      <option value="Paid">Paid</option>
                                    </select>
                                  </div>
                                  <div className="col-sm-6 mt-4">
                                    <span
                                      className={`badge ${
                                        paymentStatus === "Paid"
                                          ? "badge-success"
                                          : "badge-danger"
                                      }`}
                                    >
                                      {paymentStatus}
                                    </span>
                                  </div>
                                </div>
                                <p>
                                  By default, the status is set to{" "}
                                  <strong>Unpaid</strong>. You can update it
                                  once payment is received.
                                </p>
                              </div>
                            </div>
                          </Tab.Pane>
                          <Tab.Pane eventKey={"AboutMe"}>
                            <div className="my-post-content pt-3">
                              <div className="post-input">
                                <textarea
                                  name="textarea"
                                  id="textarea"
                                  cols="30"
                                  rows="5"
                                  className="form-control bg-transparent"
                                  defaultValue={"Please type what you want...."}
                                />
                                <Link
                                  to={"#"}
                                  className="btn btn-primary light me-1 px-3"
                                  onClick={() =>
                                    dispatch({ type: "linkModal" })
                                  }
                                >
                                  <i className="fa fa-link m-0" />
                                </Link>{" "}
                                <Link
                                  to={"#"}
                                  className="btn btn-primary light me-1 px-3"
                                  onClick={() =>
                                    dispatch({ type: "cameraModal" })
                                  }
                                >
                                  <i className="fa fa-camera m-0" />
                                </Link>{" "}
                                <Link
                                  to={"#"}
                                  className="btn btn-primary"
                                  onClick={() =>
                                    dispatch({ type: "postModal" })
                                  }
                                >
                                  Post
                                </Link>
                              </div>
                              <div className="profile-uoloaded-post border-bottom-1 pb-5">
                                <img
                                  src={IMAGES.Profile8}
                                  alt=""
                                  className="img-fluid w-100 rounded"
                                />
                                <Link
                                  to={"/post-details"}
                                  className="post-title"
                                >
                                  <h3>
                                    "Embark on a Journey of Unparalleled
                                    Excellence, Where Innovation and Elegance
                                    Converge to Shape Tomorrow's World."
                                  </h3>
                                </Link>
                                <p>
                                  A wonderful serenity has take possession of my
                                  entire soul like these sweet morning of spare
                                  which enjoy whole heart.A wonderful serenity
                                  has take possession of my entire soul like
                                  these sweet morning of spare which enjoy whole
                                  heart.
                                </p>
                                <button className="btn btn-primary me-2">
                                  <span className="me-2">
                                    <i className="fa fa-heart" />
                                  </span>
                                  Like
                                </button>
                                <button
                                  className="btn btn-secondary"
                                  onClick={() =>
                                    dispatch({ type: "replyModal" })
                                  }
                                >
                                  <span className="me-2">
                                    <i className="fa fa-reply" />
                                  </span>
                                  Reply
                                </button>
                              </div>
                              <div className="profile-uoloaded-post border-bottom-1 pb-5">
                                <img
                                  src={IMAGES.Profile9}
                                  alt=""
                                  className="img-fluid w-100 rounded"
                                />
                                <Link
                                  to={"/post-details"}
                                  className="post-title"
                                >
                                  <h3>
                                    Collection of textile samples lay spread
                                  </h3>
                                </Link>
                                <p>
                                  A wonderful serenity has take possession of my
                                  entire soul like these sweet morning of spare
                                  which enjoy whole heart.A wonderful serenity
                                  has take possession of my entire soul like
                                  these sweet morning of spare which enjoy whole
                                  heart.
                                </p>
                                <button className="btn btn-primary me-2">
                                  <span className="me-2">
                                    <i className="fa fa-heart" />
                                  </span>
                                  Like
                                </button>
                                <button
                                  className="btn btn-secondary"
                                  onClick={() =>
                                    dispatch({ type: "replyModal" })
                                  }
                                >
                                  <span className="me-2">
                                    <i className="fa fa-reply" />
                                  </span>
                                  Reply
                                </button>
                              </div>
                              <div className="profile-uoloaded-post pb-3">
                                <img
                                  src={IMAGES.Profile10}
                                  alt=""
                                  className="img-fluid w-100 rounded"
                                />
                                <Link
                                  to={"/post-details"}
                                  className="post-title"
                                >
                                  <h3>
                                    "Breakthrough Study Reveals Promising New
                                    Treatment Strategy for Alzheimer's Disease
                                  </h3>
                                </Link>
                                <p>
                                  A wonderful serenity has take possession of my
                                  entire soul like these sweet morning of spare
                                  which enjoy whole heart.A wonderful serenity
                                  has take possession of my entire soul like
                                  these sweet morning of spare which enjoy whole
                                  heart.
                                </p>
                                <button className="btn btn-primary me-2">
                                  <span className="me-2">
                                    <i className="fa fa-heart" />
                                  </span>
                                  Like
                                </button>
                                <button
                                  className="btn btn-secondary"
                                  onClick={() =>
                                    dispatch({ type: "replyModal" })
                                  }
                                >
                                  <span className="me-2">
                                    <i className="fa fa-reply"></i>
                                  </span>
                                  Reply
                                </button>
                              </div>
                            </div>
                          </Tab.Pane>
                        </Tab.Content>
                      </Tab.Container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* All Model ------ */}
      {/* Camera Model */}
      <Modal
        show={state.camera}
        onHide={() => dispatch({ type: "cameraModal" })}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title">Upload images</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => dispatch({ type: "cameraModal" })}
          ></button>
        </div>
        <div className="modal-body">
          <div className="input-group mb-3">
            <span className="input-group-text">Upload</span>
            <div className="form-file">
              <input
                type="file"
                className="form-file-input form-control  border-s-1"
              />
            </div>
          </div>
        </div>
      </Modal>
      {/* Social Modal */}
      <Modal
        className="post-input"
        show={state.link}
        onHide={() => dispatch({ type: "linkModal" })}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title">Social Links</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => dispatch({ type: "linkModal" })}
          ></button>
        </div>
        <div className="modal-body">
          <Link to={"#"} className="btn-social me-1 facebook mb-1">
            <i className="fab fa-facebook-f" />
          </Link>
          <Link to={"#"} className="btn-social me-1 google-plus mb-1">
            <i className="fab fa-google-plus-g" />
          </Link>
          <Link to={"#"} className="btn-social me-1 linkedin mb-1">
            <i className="fab fa-linkedin" />
          </Link>
          <Link to={"#"} className="btn-social me-1 instagram mb-1">
            <i className="fab fa-instagram" />
          </Link>
          <Link to={"#"} className="btn-social me-1 twitter mb-1">
            <i className="fab fa-twitter" />
          </Link>
          <Link to={"#"} className="btn-social me-1 youtube mb-1">
            <i className="fab fa-youtube" />
          </Link>
          <Link to={"#"} className="btn-social whatsapp mb-1">
            <i className="fab fa-whatsapp" />
          </Link>
        </div>
      </Modal>

      {/* Post Modal */}
      <Modal
        className="post-input"
        show={state.post}
        onHide={() => dispatch({ type: "postModal" })}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title">Post</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => dispatch({ type: "postModal" })}
          ></button>
        </div>
        <div className="modal-body">
          <textarea
            name="textarea"
            id="textarea2"
            cols="30"
            rows="3"
            className="form-control bg-transparent"
            defaultValue={"Please type what you want...."}
          />
          <Link to={"#"} className="btn btn-primary">
            Post
          </Link>
        </div>
      </Modal>
      {/* Reply Modal */}
      <Modal
        className="modal fade"
        id="replyModal"
        show={state.reply}
        onHide={() => dispatch({ type: "replyModal" })}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title">Post Reply</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => dispatch({ type: "replyModal" })}
          ></button>
        </div>
        <div className="modal-body">
          <form>
            <textarea
              className="form-control"
              rows="4"
              defaultValue={"Message"}
            />
          </form>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-danger light"
            onClick={() => dispatch({ type: "replyModal" })}
          >
            Close
          </button>
          <button type="button" className="btn btn-primary">
            Reply
          </button>
        </div>
      </Modal>
    </>
  );
}

const ProfileStaff = () => {
  return (
    <>
      <PageTitle activeMenu="Staff Profile" motherMenu={"Staff"} />
      <StaffProfile />
    </>
  );
};

export { StaffProfile };
export default ProfileStaff;
